import React, { useEffect, useMemo, useRef, useState } from 'react';

import {
    AccessibilityRole,
    Role,
    StyleProp,
    Text,
    TextStyle,
    View,
    ViewStyle,
} from 'react-native';

import { RBProgram } from 'store/railsBuilder/reducer.types';
import { RecordingMetadata } from 'store/recordings/reducer.types';

import setAccessibilityFocusTo from 'services/accessibility/setAccessibilityFocusTo';
import { VodEditorial } from 'services/data-manager/types';

import { isTabletOrWeb, isWeb } from 'utils/responsiveness';

import styles from './styles';

function DetailPageTitle({
    item,
    containerStyle,
    titleStyle,
    testID,
    detailsLoading,
    screenFocused,
}: {
    item: RBProgram | VodEditorial | RecordingMetadata;
    containerStyle?: StyleProp<ViewStyle>;
    titleStyle?: TextStyle;
    testID?: string;
    detailsLoading?: boolean;
    screenFocused: boolean;
}) {
    const [titleTabIndex, setTitleTabIndex] = useState<0 | -1>(-1);
    const titleRef = useRef(null);

    const title = item.SeriesTitle || item.Title || item.title;

    const accessibilityProps = useMemo(
        () => ({
            ref: titleRef,
            accessibilityRole: 'text' as AccessibilityRole,
            role: 'text' as Role,
            accessible: true,
            accessibilityLabel: title,
        }),
        [title],
    );

    useEffect(() => {
        if (screenFocused && !detailsLoading && titleRef.current) {
            setTimeout(() => {
                setAccessibilityFocusTo(titleRef);

                if (isWeb) {
                    setTitleTabIndex(0);
                }
            }, 100);
        }
    }, [detailsLoading, screenFocused]);

    return (
        <View
            style={[styles.container, containerStyle]}
            {...accessibilityProps}
            {...(isWeb && { tabIndex: titleTabIndex })}
        >
            <Text
                testID={testID}
                style={[styles.title, titleStyle]}
                numberOfLines={isTabletOrWeb ? 2 : 3}
                accessibilityRole="text"
                accessibilityLiveRegion="none"
                aria-hidden={isWeb}
            >
                {title}
            </Text>
        </View>
    );
}

export default DetailPageTitle;
